// extracted by mini-css-extract-plugin
export default {"container":"eSNIxLDU1B9C7BtUwTYg","label":"EvoyxYIvy5JYyCv8CcbY","description":"DwfWaTdudkjJUoFopMmO","termsContainer":"Q7zSwAXiojIZrwMzIW4p","pulse":"D_WMqz9gI2mkg2dDmmdj"};